import { Controller } from '@hotwired/stimulus';
import { Offcanvas } from 'bootstrap';

export default class SidebarNavigationController extends Controller {
  static targets = ['link', 'section', 'toggleButton', 'offcanvas', 'backToTop'];

  _scrollLockTimer = null;

  setVisibility(hidden) {
    this.toggleButtonTarget.classList.toggle('d-none', hidden);
    if (this.hasBackToTopTarget) {
      this.backToTopTarget.classList.toggle('d-none', hidden);
    }
  }

  onShow = () => this.setVisibility(true);
  onHidden = () => this.setVisibility(false);
  _onScrollEnd = () => {
    this._clearScrollLockTimer();
  };

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this._scrollLockTimer) {
            this.activateById(entry.target.id);
          }
        }
      },
      { rootMargin: '-25% 0px -70% 0px' }
    );

    this.sectionTargets.forEach((section) => this.observer.observe(section));
    this.activateById(this.sectionTargets[0]?.id);

    window.addEventListener('scrollend', this._onScrollEnd);

    if (this.hasOffcanvasTarget && this.hasToggleButtonTarget) {
      this.offcanvasTarget.addEventListener('show.bs.offcanvas', this.onShow);
      this.offcanvasTarget.addEventListener('hidden.bs.offcanvas', this.onHidden);
    }
  }

  disconnect() {
    this.observer.disconnect();
    window.removeEventListener('scrollend', this._onScrollEnd);
    this._clearScrollLockTimer();

    if (this.hasOffcanvasTarget && this.hasToggleButtonTarget) {
      this.offcanvasTarget.removeEventListener('show.bs.offcanvas', this.onShow);
      this.offcanvasTarget.removeEventListener('hidden.bs.offcanvas', this.onHidden);
    }
  }

  activate(event) {
    this._clearScrollLockTimer();
    this.activateLink(event.currentTarget);
    this._scrollLockTimer = setTimeout(() => {
      this._scrollLockTimer = null;
    }, 1000);

    if (this.hasOffcanvasTarget) {
      Offcanvas.getInstance(this.offcanvasTarget)?.hide();
    }
  }

  activateById(id) {
    const link = this.linkTargets.find((l) => l.dataset.sectionId === id);
    if (link) {
      this.activateLink(link);
    }
  }

  activateLink(activeLink) {
    this.linkTargets.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('text-primary', isActive);
      link.classList.toggle('bg-primary-subtle', isActive);
      link.classList.toggle('fw-bold', isActive);
      link.classList.toggle('text-black', !isActive);
    });
  }

  _clearScrollLockTimer() {
    if (this._scrollLockTimer) {
      clearTimeout(this._scrollLockTimer);
      this._scrollLockTimer = null;
    }
  }
}
